import styled from '@emotion/styled';
import { layout, LayoutProps } from 'styled-system';

interface Props extends LayoutProps {
  label: string;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const LinkButton = ({ label, onClick, ...props }: Props) => {
  return (
    <StyledButton {...props} type="button" onClick={onClick}>
      {label}
    </StyledButton>
  );
};

export default LinkButton;

const StyledButton = styled('button')`
  border: none;
  background: transparent;
  display: block;
  margin: 12px auto;
  font-weight: 500;
  letter-spacing: 0;
  color: white;
  font-size: 11px;
  text-decoration: underline;
  text-align: center;

  ${layout}
`;
